import { EmptyState, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import noResultsSVG from './assets/no-results.svg'
import messages from './messages'

export const GlobalSearchEmptyState = () => {
  const intl = useProcurifyIntl()

  return (
    <EmptyState
      context='information'
      imgUrl={noResultsSVG}
      header={intl.formatMessage(messages.header)}
      content={<Text>{intl.formatMessage(messages.content)}</Text>}
    />
  )
}
